import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../../components/TextField';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import LoaderButton from '../../../../components/LoaderButton';
import {map, filter, includes, pull, omit, reduce} from 'lodash';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {required} from '../../../../helpers/Validators';
import FieldError from '../../../../components/FieldError';
import permissions from '../../../../constants/permissions';
import Skeleton from 'react-loading-skeleton';
import Api from '../../../../services/Api';
import Select from 'react-select';

class Update extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rbac: null,
      loading: true,
      role: props.location.state.role,
    };
    const username = localStorage.getItem('username');
    this.permissionOptions = reduce(permissions, (result, item) => {
      if (username !== "superadmin" && item.onlyForSuperAdmin) {
        return result;
      }
      return [...result, item];
    }, []);
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/rbac');
      this.setState({
        rbac: data,
        loading: false,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  updateRole = async values => {
    const {t} = this.props;
    const {rbac, role} = this.state;
    const newRoles = pull(rbac.roles, role);
    const newGrants = omit(rbac.grants, [role]);
    const newRbac = {
      ...rbac,
      roles: [...newRoles, values.title],
      grants: {...newGrants, [values.title]: map(values.permissions, 'value')},
    };
    try {
      await Api.invoke('PUT', '/admin-ui/rbac', {
        rbac: JSON.stringify(newRbac),
      });
      this.setState({role: values.title, rbac: newRbac});
      NotificationManager.success(t('Role updated successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
    />
  );

  render() {
    const {t, match} = this.props;
    const {loading, role, rbac} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Update Role')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.updateRole}
                  initialValues={{
                    title: role,
                    permissions: rbac && rbac.roles ?
                      filter(
                        [...rbac.roles.map(role => ({label: role, value: role})), ...permissions],
                        obj => includes(rbac.grants[role], obj.value)
                      ) :
                      [],
                  }}
                  render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            {!loading ?
                              <TextField
                                item={{
                                  name: 'title',
                                  i18n: t('Role Title'),
                                  type: 'text',
                                  required: true,
                                }}
                              />
                              :
                              <Skeleton height={40}/>
                            }
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                           <span>
                             {t('Permissions')}
                             <span className="required">*</span>
                           </span>
                            <Field
                              name="permissions"
                              component={this.ReactSelectAdapter}
                              isLoading={loading}
                              options={rbac && rbac.roles ?
                                [...pull(rbac.roles, role).map(role => ({label: role, value: role})), ...this.permissionOptions] :
                                this.permissionOptions
                              }
                              validate={required}
                              closeMenuOnSelect={false}
                            />
                            <FieldError name='permissions' />
                          </Col>
                        </Row>
                        <LoaderButton
                          loading={submitting}
                          onClick={handleSubmit}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-4 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Save')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Update);
